import { _ as _extends } from '../../extends-30811c5e.js';
import { _ as _defineProperty } from '../../defineProperty-6f298737.js';
import { _ as _objectWithoutProperties } from '../../objectWithoutProperties-dd908bcc.js';
import React__default from 'react';
import classNames from 'classnames';

var _excluded = ["highlightColor", "size", "className"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

/* eslint-disable @typescript-eslint/no-unused-vars */

var IconStar = function IconStar(_ref) {
  _ref.highlightColor;
    var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 16 : _ref$size,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    newProps = _objectWithoutProperties(_ref, _excluded);
  var props = _objectSpread(_objectSpread({
    width: size,
    height: size
  }, newProps), {}, {
    className: classNames('sol-icon', className)
  });
  return /*#__PURE__*/React__default.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), /*#__PURE__*/React__default.createElement("g", {
    id: "icon-star"
  }, /*#__PURE__*/React__default.createElement("path", {
    id: "Vector",
    d: "M20.4182 9.33831L15.0222 8.51709L12.61 3.39615C12.5441 3.25594 12.4357 3.14244 12.3018 3.07345C11.966 2.89986 11.558 3.04452 11.3901 3.39615L8.97791 8.51709L3.58186 9.33831C3.4331 9.36057 3.29708 9.43401 3.19294 9.54529C3.06704 9.68079 2.99767 9.86309 3.00006 10.0521C3.00245 10.2412 3.07641 10.4215 3.20569 10.5535L7.10981 14.5394L6.18744 20.1677C6.16581 20.2987 6.17965 20.4333 6.22738 20.5564C6.27511 20.6795 6.35483 20.7862 6.45749 20.8643C6.56016 20.9424 6.68166 20.9887 6.80823 20.9982C6.9348 21.0076 7.06136 20.9798 7.17356 20.9177L12 18.2605L16.8265 20.9177C16.9583 20.9912 17.1113 21.0157 17.258 20.989C17.6277 20.9222 17.8764 20.555 17.8126 20.1677L16.8903 14.5394L20.7944 10.5535C20.9007 10.4444 20.9708 10.302 20.992 10.1462C21.0494 9.75671 20.7901 9.39618 20.4182 9.33831Z",
    fill: "currentColor"
  })));
};

export { IconStar };
